import React, { createContext, useState, useContext, useEffect } from "react";

const SessionContext = createContext();

let externalSetSessionExpired = null;
let externalSetNetworkError = null;

export const SessionProvider = ({ children }) => {
  const [sessionExpired, setSessionExpired] = useState(false);
  const [networkError, setNetworkError] = useState(false);

  useEffect(() => {
    externalSetSessionExpired = setSessionExpired;
    externalSetNetworkError = setNetworkError;
  }, []);

  return (
    <SessionContext.Provider
      value={{
        sessionExpired,
        setSessionExpired,
        networkError,
        setNetworkError,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};

export const triggerSessionExpired = () =>
  externalSetSessionExpired?.(true);

export const triggerNetworkError = () =>
  externalSetNetworkError?.(true);

export const useSession = () => useContext(SessionContext);


// import React, { createContext, useState, useContext } from 'react';

// const SessionContext = createContext();

// let externalSetSessionExpired = null;
// let externalSetNetworkError = null;

// export const SessionProvider = ({ children }) => {
//   const [sessionExpired, setSessionExpired] = useState(false);
//   const [networkError, setNetworkError] = useState(false);

//   externalSetSessionExpired = setSessionExpired;
//   externalSetNetworkError = setNetworkError;

//   return (
//     <SessionContext.Provider value={{ sessionExpired, setSessionExpired, networkError, setNetworkError }}>
//       {children}
//     </SessionContext.Provider>
//   );
// };

// export const triggerSessionExpired = () => {
//   if (externalSetSessionExpired) {
//     externalSetSessionExpired(true);
//   }
// };

// export const triggerNetworkError = () => {
//   if (externalSetNetworkError) {
//     externalSetNetworkError(true);
//   }
// };

// export const useSession = () => useContext(SessionContext);
